export default "__VITE_ASSET__DaRaf3Wp__"